// Libs
import { createSlice } from '@reduxjs/toolkit';
// Others
import { RootState } from '~/utils/redux/store';
import { createCallHistory, getActivityList } from './activityThunk';

export interface IActivityState {
  isRefreshActivityList: boolean;
}

export const initialState: IActivityState = {
  isRefreshActivityList: false,
};

const activitySlice = createSlice({
  name: 'activity',
  initialState,
  reducers: {
    setRefreshEmployeeList(state, action) {
      state.isRefreshActivityList = action.payload;
    },
  },
  extraReducers(builder) {
    // GET: Get activity list
    builder
      .addCase(getActivityList.pending, (state) => {})
      .addCase(getActivityList.fulfilled, (state) => {})
      .addCase(getActivityList.rejected, (state) => {});

    // POST: Create call history
    builder
      .addCase(createCallHistory.pending, (state) => {})
      .addCase(createCallHistory.fulfilled, (state) => {})
      .addCase(createCallHistory.rejected, (state) => {});
  },
});

// Action
export const activityActions = activitySlice.actions;

// Selectors
export const selectIsRefreshActivityList = (state: RootState) => state.activity.isRefreshActivityList;

// Reducer
const activityReducer = activitySlice.reducer;
export default activityReducer;
